import { render, staticRenderFns } from "./AddAwardManualDialog.vue?vue&type=template&id=6e151ed6"
import script from "./AddAwardManualDialog.vue?vue&type=script&lang=js"
export * from "./AddAwardManualDialog.vue?vue&type=script&lang=js"
import style0 from "./AddAwardManualDialog.vue?vue&type=style&index=0&id=6e151ed6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports